export enum FollowUpStudyCompletionResponseSource {
	Insaf = "INSAF",
}
